module.exports = __webpack_public_path__ + "img/57_7.87a7192e.png";